$(document).ready(function(){
	$(document).ready(function(){
		if($('.auth-container').length > 0){
			$('.social a').removeAttr('style');
		}
	});
	if(window.location.hash == '#reset-pass-success'){
		setTimeout(function(){
			$('.reset-success').fadeIn(1000)
		}, 1500);
	}
	$(window).on('scroll', function(){
		if($(window).scrollTop() >= $(document).height() / 3){
			$('.go-to-top').fadeIn(500);
		}
		else{
			$('.go-to-top').fadeOut(500);
		}
	});
	$('.go-to-top').on('click', function (e) {
		e.preventDefault();
		window.scrollTo({top: 0, behavior: 'smooth'});
	});
	$('.product-archive-view .icons').on('click', function (e) {
		e.preventDefault();
	});
	$(window).on('scroll', function(){
		if($(window).scrollTop() >= 180 && $(window).width() > 991){
			$('header.fixed').fadeIn(500);
			$('header.header').find('.desktop-search').fadeOut(500);
		}
		else{
			$('header.fixed').fadeOut(100);
			$('header.fixed').find('.desktop-search').fadeOut(500);
		}
	});
	$('header.header .open-search-box, header.fixed .open-search-box').on('click', function(e){
		e.preventDefault();
		$('header.header').find('.desktop-search').width($('header.header .container').width() - $('header.header .go-to-home').width());
		$('header.fixed').find('.desktop-search').width($('header.fixed .container').width() - $('header.fixed .go-to-home').width());
		var th = $(this);
		setTimeout(function(){
			th.closest('header').find('.desktop-search').fadeIn(500);
		}, 500)
	});
	if($(window).width() > 991){

	}
	if($(window).width() < 992 && $('.topbar').length > 0){
		var counter = 0;
		$('.topbar .icon').each(function(){
			counter = counter + $(this).width();
		});
		$('.topbar .icons').width(parseInt(counter) + 100 + 'px')
	}
	if($(window).width() < 992 && $('.ambassador-slider-container').length > 0){
		var counter = 0;
		$('.ambassador-slider-container .item').each(function(){
			counter = counter + $(this).width();
		});
		$('.ambassador-slider-container .ambassador-slider').width(parseInt(counter) + 100 + 'px')
	}
	$('header.mobile-header .search').on('click', function(e){
		e.preventDefault();
		$(this).closest('header').find('.search-container').css('display', 'flex');
	});
	$('header.mobile-header .search-container .close, .desktop-search .close').on('click', function(e){
		e.preventDefault();
		$(this).closest('header').find('.search-container, .desktop-search').fadeOut(500);
	});
	$('body input[type="checkbox"]:not([id="ship-to-different-address-checkbox"])').each(function(){
		$(this).wrap('<div class="checkbox-container" />');
		$('<span class="checkmark"></span>').insertAfter($(this));
	});
	function radio_muskolo_radio(){
		$('body input[type="radio"]').each(function(){
			if(!$(this).parent().hasClass('radio-container')) {
				$(this).wrap('<div class="radio-container" />');
				$('<span class="checkmark"></span>').insertAfter($(this));
			}
		})
	}
	$( 'body' ).on( 'updated_checkout', function() {
		radio_muskolo_radio();
	});
	$('body').on('click', '.checkmark', function(){
		if($(this).parent().hasClass('radio-container')){
			$(this).parent().find('input').prop('checked', true).trigger('change');
		}
	})
});

$('.mobile-header .bars').on('click', function(e){
	e.preventDefault();
	var left = $('.mobile-menu-container').offset().left;
	$('.mobile-menu-container').css({left:left}).animate({"left":"0px"}, "slow");
});
$('.mobile-menu-container > .close').on('click', function(e){
	e.preventDefault();
	$('.mobile-menu-container').css({left:0}).animate({"left":"-100vw"}, "slow");
});
$('.mobile-menu-container .search .open-search').on('click', function(e){
	e.preventDefault();
	$('.open-search').hide();
	$(this).next('form').css('display', 'flex');
});
$('.mobile-menu-container .search .close').on('click', function(e){
	e.preventDefault();
	$('.open-search').show();
	$(this).closest('form').hide();
});
$('.mobile-menu-container .menu-item-has-children > a').on('click', function(e){
	e.preventDefault();
	$(this).closest('.menu-item-has-children').toggleClass('active');
});

$('#login-user').on('submit', function(e){
	e.preventDefault();
	ajax_login();
});

$( document.body ).on( 'price_slider_create', function( e, min, max ) {
	window.priceFilterRange = [ min, max ];
} );
$( document.body ).on( 'price_slider_change', function( e, min, max ) {
	if ( window.priceFilterRange[0] != min || window.priceFilterRange[1] != max ) {
		$('.widget_price_filter form').submit();
	}
} );